import TreeMap from './TreeMap';

export default TreeMap;
